import React, { useState } from "react";
import FilterShell from "./FilterShell";

const defaultState = {
  name: "",
  address: "",
  status: "",
  vehicleType: "",
  hasEvCharger: "",
};

const UserSpotsFilters = ({ onApply, initial = null }) => {
  const [data, setData] = useState({ ...defaultState, ...(initial || {}) });

  const onChange = (e) =>
    setData((d) => ({ ...d, [e.target.name]: e.target.value }));

  return (
    <FilterShell
      onApply={() => onApply(data)}
      onClear={() => {
        setData(defaultState);
        onApply(defaultState);
      }}
    >
      <div className="col-md-3">
        <label className="form-label">Name</label>
        <input
          type="text"
          name="name"
          className="form-control"
          value={data.name}
          onChange={onChange}
        />
      </div>
      <div className="col-md-3">
        <label className="form-label">Address</label>
        <input
          type="text"
          name="address"
          className="form-control"
          value={data.address}
          onChange={onChange}
        />
      </div>
      <div className="col-md-3">
        <label className="form-label">Status</label>
        <select
          name="status"
          className="form-control"
          value={data.status}
          onChange={onChange}
        >
          <option value="">All</option>
          <option value="draft">Draft</option>
          <option value="published">Published</option>
        </select>
      </div>
      <div className="col-md-3">
        <label className="form-label">Vehicle Type</label>
        <select
          name="vehicleType"
          className="form-control"
          value={data.vehicleType}
          onChange={onChange}
        >
          <option value="">All types</option>
          <option value="compact">Compact</option>
          <option value="standard">Standard</option>
          <option value="suv">SUV</option>
        </select>
      </div>
      <div className="col-md-3">
        <label className="form-label">EV Charger</label>
        <select
          name="hasEvCharger"
          className="form-control"
          value={data.hasEvCharger}
          onChange={onChange}
        >
          <option value="">Any</option>
          <option value="true">With EV charger</option>
          <option value="false">Without EV charger</option>
        </select>
      </div>
    </FilterShell>
  );
};

export default UserSpotsFilters;
